import React from 'react';
import './shared.css';

const Shop: React.FC = () => {
  return (
    <div className="page-container">
      <div className="content-card">
        <h1>Shop</h1>

        <p>
          <span style={{ color: '#ff0000' }}>
            <em><strong>Payments please call +1 (800) 660-7156</strong></em>
          </span>
        </p>
        <p>
          <em>Leave a voice mail message and we will get back to you shortly</em>
        </p>
        <p>
          <em>Thank you for your business</em>
        </p>

        <hr />
      </div>
    </div>
  );
};

export default Shop;

